import { installGlobalChunkErrorHandlers } from "./utils/chunkRecovery";
import { migrateLegacyEnvironment } from "./utils/envMigration";

installGlobalChunkErrorHandlers();
migrateLegacyEnvironment();

import("./App").catch((err) => {
  console.error("[bootstrap] failed to load App:", err);
  if (!sessionStorage.getItem("__chunk_reload_attempted__")) {
    sessionStorage.setItem("__chunk_reload_attempted__", "1");
    window.location.reload();
  }
});
